import './i18n/setup' // side effect: registers admin-mobifull namespace
import { ApolloProvider } from '@base-app/web2'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { apolloClient } from './lib/apollo'

import '@base-app/web2/styles.css'
import './styles.css'

// biome-ignore lint/style/noNonNullAssertion: root element always exists
const container = document.getElementById('root')!
const root = createRoot(container)
root.render(
  <StrictMode>
    <ApolloProvider client={apolloClient}>
      <App />
    </ApolloProvider>
  </StrictMode>,
)
